import { Flex } from 'antd';

import { Schemas } from '@api-client/generated/types';
import { IconEditUnderline, IconTrash } from '@assets';
import { DEFAULT_CURRENCY_CODE } from '@constants';
import { Amount } from '@entities';

import * as S from './styled';

type InvoiceItem = Schemas.InvoiceItem;

type BillingServicesListItemProps = {
  details: InvoiceItem;
  index: number;
  onEdit: (details: InvoiceItem, index: number) => void;
  onDelete: (index: number) => void;
  canManageServices: boolean;
};

const BillingServicesListItem = ({
  details,
  index,
  onEdit,
  onDelete,
  canManageServices,
}: BillingServicesListItemProps) => (
  <S.Item
    gap={6}
    justify="center"
    className={canManageServices ? 'service-item--manageable' : undefined}
    tabIndex={canManageServices ? 0 : undefined}
    vertical
  >
    <Flex align="center" justify="space-between" gap={16}>
      <Flex vertical>
        <S.Title>{details.name}</S.Title>
        <S.Description>{details.description}</S.Description>
      </Flex>

      <Amount
        className="service-amount"
        currencyCode={DEFAULT_CURRENCY_CODE}
        amount={details.totalPrice}
        withoutType
      />

      {canManageServices && (
        <S.Actions className="service-actions" align="center" gap={4}>
          <S.ButtonEdit
            type="link"
            icon={<IconEditUnderline />}
            size="large"
            aria-label="Edit service"
            onClick={() => onEdit(details, index)}
          />

          <S.ButtonDelete
            type="link"
            icon={<IconTrash />}
            size="large"
            aria-label="Delete service"
            onClick={() => onDelete(index)}
          />
        </S.Actions>
      )}
    </Flex>
  </S.Item>
);

export default BillingServicesListItem;
